<template>
  <div class="container mt-4">
     <!-- Breadcrumb -->
     <b-breadcrumb class="m-3">
      <b-breadcrumb-item href="/"> <i class="fa fa-home" aria-hidden="true"></i> Home</b-breadcrumb-item>
      <b-breadcrumb-item href="/residentslist-ins"> Residents</b-breadcrumb-item>
      <b-breadcrumb-item active> {{ getBread("-ins") }}</b-breadcrumb-item>
    </b-breadcrumb>
    <div class="customCard">
      <h1 style="font-size: 2rem; text-align: center; padding-bottom: 1rem">
        List of Insurances {{ fullName }}
      </h1>
    </div>

    <div v-if="loading" class="text-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else-if="error" class="text-center text-danger">
      <p>Error loading data.</p>
    </div>
    <div v-else>
      <div v-if="getUserRole('admins')">
      <button class="btn btn-primary mb-4" @click="showAddModal = true">
        Add Insurance
      </button>
    </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">Provider Name</th>
            <th scope="col">Insurance Type</th>
            <th scope="col">Insurance ID No.</th>
            <th scope="col">Group No.</th>
            <th scope="col" v-if="getUserRole('admins') || getUserRole('editors')">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="insurance in paginatedInsurances" :key="insurance.id">
            <td> <a href="#" @click.prevent="viewEntry(insurance)">
              {{ insurance.attributes.providername }}
            </a>
            </td>
            <td>{{ getInsuranceTypeText(insurance.attributes.insurancetype) }}</td>
            <td>{{ insurance.attributes.insuranceidno }}</td>
            <td>{{ insurance.attributes.groupno }}</td>
            <td v-if="getUserRole('admins') || getUserRole('editors')"><a href="#" @click.prevent="editEntry(insurance)">Edit</a> </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-between align-items-center">
        <p>
          Showing {{ startIndex + 1 }} to {{ endIndex }} of
          {{ result.residentinsurances.data.length }} entries
        </p>
        <ul class="pagination">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <a
              class="page-link"
              href="#"
              @click.prevent="changePage(currentPage - 1)"
              >Prev</a
            >
          </li>
          <li
            class="page-item"
            v-for="page in totalPages"
            :key="page"
            :class="{ active: currentPage === page }"
          >
            <a class="page-link" href="#" @click.prevent="changePage(page)">{{
              page
            }}</a>
          </li>
          <li
            class="page-item"
            :class="{ disabled: currentPage === totalPages }"
          >
            <a
              class="page-link"
              href="#"
              @click.prevent="changePage(currentPage + 1)"
              >Next</a
            >
          </li>
        </ul>
      </div>
    </div>

    <!-- Edit Modal -->
    <b-modal size="xl" v-model="showEditModal" hide-footer :title="'Edit Insurance '+fullName">
      <form v-if="currentInsurance" @submit.prevent="updateEntry">
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3">
              <label for="providername" class="form-label">Provider Name</label>
              <input
                type="text"
                class="form-control"
                id="providername"
                v-model="currentInsurance.attributes.providername"
              />
            </div>           
            <div class="mb-3">
              <label for="insurancetype" class="form-label">Insurance Type</label>
              <select
                class="form-select"
                id="insurancetype"
                v-model="currentInsurance.attributes.insurancetype"                
              >
                <option
                  v-for="option in insuranceTypes"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="insuranceidno" class="form-label">Insurance ID No.</label>
              <input
                type="text"
                class="form-control"
                id="insuranceidno"
                v-model="currentInsurance.attributes.insuranceidno"                
              />
            </div>
            
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="groupno" class="form-label">Group No.</label>
              <input
                type="text"
                class="form-control"
                id="groupno"
                v-model="currentInsurance.attributes.groupno"                
              />
            </div>  
          </div>
          <div class="d-grid">
            <button type="submit" class="btn btn-primary">Save changes</button>
          </div>
        </div>
      </form>
      <div v-if="updateError" class="alert alert-danger mt-3">
        {{ updateError }}
      </div>
    </b-modal>

     <!-- View Modal -->
     <b-modal size="xl" v-model="showViewModal" hide-footer :title="'View Insurance '+fullName">
      <form v-if="currentInsurance">
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Provider Name:</strong>
              <span>{{ currentInsurance.attributes.providername }} </span>
            </div>           
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Insurance Type:</strong>
              <span>{{ getInsuranceTypeText(currentInsurance.attributes.insurancetype) }}</span>               
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Insurance UD No.:</strong>
              <span>{{ currentInsurance.attributes.insuranceidno }} </span>                
            </div>          
          </div>
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Group No.:</strong>
              <span>{{ currentInsurance.attributes.groupno }}</span>              
            </div>                       
          </div>         
        </div>
      </form>
    </b-modal>

    <!-- Add Modal -->
    <b-modal size="xl" v-model="showAddModal" hide-footer :title="'Add Insurance '+fullName">
      <form @submit.prevent="addEntry">
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3">
              <label for="providername" class="form-label">Provider Name</label>
              <input
                type="text"
                class="form-control"
                id="providername"
                v-model="newInsurance.providername"
                required
              />
            </div>           
            <div class="mb-3">
              <label for="insurancetype" class="form-label">Insurance Type</label>
              <select
                class="form-select"
                id="insurancetype"
                v-model="newInsurance.insurancetype"
                required
              >
                <option
                  v-for="option in insuranceTypes"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="insuranceidno" class="form-label">Insurance ID No.</label>
              <input
                type="text"
                class="form-control"
                id="insuranceidno"
                v-model="newInsurance.insuranceidno"
                required
              />
            </div>            
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="groupno" class="form-label">Group No.</label>
              <input
                type="text"
                class="form-control"
                id="groupno"
                v-model="newInsurance.groupno"
              />
            </div>            
          </div>
          <div class="d-grid">
            <button type="submit" class="btn btn-primary">Add insurance</button>
          </div>
        </div>
      </form>
      <div v-if="addError" class="alert alert-danger mt-3">
        {{ addError }}
      </div>
    </b-modal>
  </div>
</template>
  
  <script>
import { useQuery, useMutation } from "@vue/apollo-composable";
import { GET_INSURANCES_BY_RESIDENT, UPDATE_INSURANCE, CREATE_INSURANCE, GET_FULLNAME_BY_ID } from "../hooks/queries";
import { ref,computed } from "vue";
import { insuranceTypes, usStates, getBread,getUserRole } from "../components/values";
import { useRoute } from 'vue-router'; // Import useRoute from Vue Router  

export default {
  name: "App",
  
  setup() {
    const route = useRoute(); // Use useRoute to get the current route
    const residentId = route.params.id; // Access the route parameter directly
    const { result:result, loading:loading, error:error, refetch:refetch } = useQuery(GET_INSURANCES_BY_RESIDENT,{residentId: residentId});
    const { mutate: updateResidentinsurance } = useMutation(UPDATE_INSURANCE);
    const { mutate: createInsurance } = useMutation(CREATE_INSURANCE);
    const currentInsurance = ref(null);
    const updateError = ref(null);
    const addError = ref(null);
    const showEditModal = ref(false);
    const showAddModal = ref(false);
    const showViewModal = ref(false);

    const {result:resultfullname, loading:loadingfullname, error:errorfullname, refetch:refetchfullname } = useQuery(GET_FULLNAME_BY_ID, {
      id: residentId,
    });

      // Watch the result and compute the full name only when the data is available
      const fullName = computed(() => {
      const data = resultfullname.value?.resident?.data;
      if (data) {
        return `(${data.attributes.firstname} ${data.attributes.lastname})`;
      }
      return null;
    });


    const newInsurance = ref({
      providername: "",
      insurancetype: "",     
      insuranceidno: "",
      groupno: "",
      publishedAt: new Date().toISOString(),
    });

    const addEntry = async () => {
      addError.value = null;
      try {
        await createInsurance({
          data: {
            resident: residentId, // Include the residentId in the input data
            providername: newInsurance.value.providername,            
            insurancetype: newInsurance.value.insurancetype,            
            insuranceidno: newInsurance.value.insuranceidno,
            groupno: newInsurance.value.groupno,
            publishedAt: new Date().toISOString(),
          },
        });
        showAddModal.value = false;
        newInsurance.value = {
          providername: "",
          insurancetype: "",
          insuranceidno: "",
          groupno: "",
        };
        await refetch(); // Refetch the list of insurances after adding a new one
        await refetchfullname();
      } catch (e) {
        //console.error("Error adding entry:", e);
        addError.value = `Failed to add insurance. Please try again.}`;
      }
    };

    const formatDate = (date) => {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString(undefined, options);
    };

    const editEntry = (insurance) => {
      //currentInsurance.value = { ...insurance }; // Copy insurance to avoid directly modifying the original data
      currentInsurance.value = JSON.parse(JSON.stringify(insurance)); // Create a deep copy of the docuement object
      showEditModal.value = true;
    };

    const updateEntry = async () => {
      updateError.value = null; // Reset the error message
      try {
        await updateResidentinsurance({
          id: currentInsurance.value.id,
          data: {
            providername: currentInsurance.value.attributes.providername,            
            insurancetype: currentInsurance.value.attributes.insurancetype,            
            insuranceidno: currentInsurance.value.attributes.insuranceidno,
            groupno: currentInsurance.value.attributes.groupno,
          },
        });
        //console.log("Updated entry:", currentInsurance.value);
        showEditModal.value = false;
      } catch (error) {
        //console.error("Error updating entry:", error);
        updateError.value = "Failed to update Insurance. Please try again.";
      }
    };

    const viewEntry = (insurance) => {
      currentInsurance.value = JSON.parse(JSON.stringify(insurance)); // Create a deep copy of the insurance object
      showViewModal.value = true;
    };

    const getInsuranceTypeText = (value) => {
      const option = insuranceTypes.find((option) => option.value === value);
      return option ? option.text : "";
    };

    const getStates = (value) => {
      const option = usStates.find((option) => option.value === value);
      return option ? option.text : "";
    };

    return {
      result,
      loading,
      error,
      formatDate,
      showEditModal,
      showAddModal,
      showViewModal,
      currentInsurance,
      newInsurance,
      editEntry,
      viewEntry,
      updateEntry,
      addEntry,
      updateError,
      addError,
      insuranceTypes,
      getInsuranceTypeText,
      getStates,
      usStates,
      getBread,
      getUserRole,
      residentId,
      errorfullname,
      loadingfullname,
      fullName,   
    };
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(
        this.result.residentinsurances.data.length / this.itemsPerPage
      );
    },
    paginatedInsurances() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.result.residentinsurances.data.slice(
        start,
        start + this.itemsPerPage
      );
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    endIndex() {
      return Math.min(
        this.startIndex + this.itemsPerPage,
        this.result.residentinsurances.data.length
      );
    },    
  },
  methods: {
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
};
</script>
  
  <style>
.container {
  max-width: 80%;
}

.d-grid {
  background-color: #e8e8e8;
  margin-bottom: 20px;
}

.text-center {
  text-align: center;
}
.spinner-border {
  margin-top: 20px;
}
.pagination {
  margin: 0;
}
</style>
  
